import script from "./MessageListView.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageListView.vue?vue&type=script&setup=true&lang=js"

import "./MessageListView.vue?vue&type=style&index=0&id=f13cb07e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f13cb07e"]])

export default __exports__